// @ts-strict-ignore

import type { Module, Store } from 'vuex'
import type { VuexOidcState } from 'vuex-oidc'
import type { StorageService } from '../../services'
import { vuexOidcCreateStoreModule, vuexOidcCreateUserManager } from 'vuex-oidc'
import { CONTAINER } from '../../config'
import { TYPES } from '../../config/inversify.types'
import { ROUTER_CONSTS } from '../../router/router.consts'
import { AUTH_CONSTS } from '../auth/auth.consts'
import { getOidcSettings } from './oidc-config'

export { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'
const loginPath = `/${ROUTER_CONSTS.routes.login}`

export const OIDC_MODULE_METHOD = (): Module<VuexOidcState, any> => {
  const settings = getOidcSettings()
  const userManager = vuexOidcCreateUserManager(settings)

  return vuexOidcCreateStoreModule(
    settings,
    // Optional OIDC store settings
    {
      namespaced: true,
      publicRoutePaths: [loginPath],
      dispatchEventsOnWindow: true,
    },
    // Optional OIDC event listeners
    {
      userLoaded: async user => {
        const store = CONTAINER.get<Store<any>>(TYPES.Store)
        const token = user.access_token

        await store.dispatch(`${AUTH_CONSTS.moduleName}/${AUTH_CONSTS.actions.setToken}`, token)
        const storageService: StorageService = CONTAINER.get<StorageService>(TYPES.StorageService)
        storageService.setItem(AUTH_CONSTS.storage.token, token)
      },
      accessTokenExpiring() {
        userManager.signinRedirect()
      },
    },
  )
}
